import { faRightLong as farRightLong } from "@awesome.me/kit-3777c2145e/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { addParameterToURL } from "bm-ui-kit";
import compact from "lodash/compact";
import type { ReactNode } from "react";
import React from "react";

interface Props {
	className?: string;
	title: ReactNode;
	icon: ReactNode;
	buttonText?: string;
	href?: string;
	children: ReactNode;
}

export class FeatureBox extends React.PureComponent<Props> {
	public render(): ReactNode {
		const { children, className, buttonText } = this.props;

		const mainClassName = compact(["feature-box", className]).join(" ");

		return (
			<div className={mainClassName}>
				{this.renderHeader()}
				<div className="feature-box-body">{children}</div>
				{buttonText && (
					<a className="feature-box-link" href={this.getHref()}>
						{buttonText}
						<FontAwesomeIcon icon={farRightLong} className="ml-2" />
					</a>
				)}
			</div>
		);
	}

	private renderHeader(): ReactNode {
		const { icon, title, href } = this.props;
		const content = (
			<>
				<div className="feature-box-icon">
					{icon}
					<div />
				</div>

				<h3 className="feature-box-title">{title}</h3>
			</>
		);

		if (href) {
			return (
				<a className="text-reset text-decoration-none" href={this.getHref()}>
					{content}
				</a>
			);
		}

		return content;
	}

	private getHref(): string {
		const { href } = this.props;

		if (!href) {
			return undefined;
		}

		const params: Record<string, string> = {
			link_type: "landing-feature-box",
		};

		return addParameterToURL(href, params);
	}
}
